module.exports = __webpack_public_path__ + "img/Preschoolers.52e2fd09.svg";